<!--
 * @Author: ZJJ
 * @Date: 2025-11-11 09:15:59
 * @LastEditTime: 2025-11-27 15:53:55
 * @FilePath: /boluo_website/src/components/column/singlePlayCard.vue
 * @Description: 专栏-列表-播放控件      int32 needPay = 4;// 是否需要购买 0 默认 1 是 2 否

-->
<template>
  <div class="containerCard" @click="handleCard">
    <div class="mainArea">
      <div class="idMark" :style="{ color: idMarkColor }">{{ info.idx }}</div>
      <div class="intro" :style="{ color: introColor }">{{ info.name }}</div>
      <div class="loading-btn" v-if="isLoading && isCurrentTrackPlaying">
        <t-loading theme="circular" size="18px" class="wrapper" />
      </div>
      <div class="iconShow" v-else @click.stop="playState">
        <!-- 需要购买：显示锁定图标 -->
        <svg-icon
          class="lock"
          icon-class="lock"
          v-if="!info.isUnLock"
        ></svg-icon>
        <!-- 正在播放：显示暂停图标 -->
        <svg-icon
          class="pause"
          icon-class="pause"
          v-else-if="info.isUnLock && isCurrentTrackPlaying"
        ></svg-icon>
        <!-- 未播放或已暂停：显示播放图标 -->
        <svg-icon
          class="play"
          icon-class="play"
          v-else-if="info.isUnLock && !isCurrentTrackPlaying"
        ></svg-icon>
      </div>
    </div>

    <div class="content-info">
      <!-- 播放时长 -->
      <div class="flex-center">
        <svg-icon
          class="u-margin-right-4 icon-size-12"
          icon-class="finish"
          v-if="info.progress >= info.duration"
        ></svg-icon>
        <svg-icon
          class="u-margin-right-4 icon-size-12"
          icon-class="timeLine"
          v-else
        ></svg-icon>
        {{ formattedProgressTime }}
        <!-- {{ getTimeDisplay(info.duration, info.progress) }} -->
      </div>

      <span class="timestamp">{{
        timestampToRelativeText(info.createTime)
      }}</span>

      <!-- 播放次数 -->
      <div class="flex-center">
        <svg-icon
          class="u-margin-right-4 icon-size-12"
          icon-class="triangle"
        ></svg-icon
        >{{ info.playNumber }}
      </div>
    </div>
  </div>
</template>

<script>
import AudioMixin from "@/mixins/audioMixin";
import { timeUtils } from "@/utils/common.js";
import { mapActions } from "vuex";
export default {
  mixins: [AudioMixin],
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    // 章节列表（用于播放当前音频）
    chapterList: {
      type: Array,
      default: () => []
    },
    // 播放列表信息（课程/有声书信息）
    courseInfo: {
      type: Object,
      default: () => null
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    formattedProgressTime() {
      // 只在整秒更新，减少频繁计算
      const progress = Math.floor(this.info.progress || 0);
      const duration = this.info.duration || 0;

      return timeUtils.getDisplayTime(duration, progress);
    },
    isPlayListLoading() {
      if (!this.currentTrack || !this.info) {
        return false;
      }
      // 通过 id 或 customId 判断是否是当前播放的音频
      const currentId = this.currentTrack.id || this.currentTrack.customId;
      const infoId = this.info.id || this.info.customId;
      return currentId === infoId && this.isLoading;
    },
    /**
     * 判断当前卡片的音频是否正在播放
     */
    isCurrentTrackPlaying() {
      if (!this.currentTrack || !this.info) {
        return false;
      }
      // 通过 id 或 customId 判断是否是当前播放的音频
      const currentId = this.currentTrack.customId;
      const infoId = this.info.customId;
      return currentId === infoId && this.isPlaying;
    },

    /**
     * 判断当前卡片是否是选中的音频（无论是否播放）
     */
    isCurrentTrack() {
      if (!this.currentTrack || !this.info) {
        return false;
      }
      const currentId = this.currentTrack.customId;
      const infoId = this.info.customId;
      return currentId === infoId;
    },

    idMarkColor() {
      // 如果是当前音频，返回橙色
      if (this.isCurrentTrack) {
        return "#f87527";
      }
      // 默认返回黑色
      return "#262626";
    },
    introColor() {
      // 如果是当前音频，返回橙色
      if (this.isCurrentTrack) {
        return "#f87527";
      }
      // 默认返回黑色
      return "#262626";
    }
  },
  mounted() {},
  watch: {},
  methods: {
    handleCard() {
      if (this.isPlaying && this.isCurrentTrackPlaying) return;
      this.playState();
    },
    ...mapActions(["openPayDialog"]),

    timestampToRelativeText(time) {
      return timeUtils.timestampToRelativeText(time);
    },
    // 时间显示逻辑
    // getTimeDisplay(duration, progress) {
    //   const progress1 = Math.floor(progress || 0);
    //   const duration1 = duration || 0;
    //   return timeUtils.getDisplayTime(duration1, progress1);
    // },
    /**
     * 点击播放区域
     */
    async playState() {
      if (!localStorage.getItem("token")) {
        this.$message.error("操作无效，请登录后重试");
        return;
      }
      // needPayState 是否需要购买 0 默认 1 是 2 否
      if (!this.info.isUnLock) {
        let customId = this.info.customId;
        let parts = customId.split("-");
        let payType = parseInt(parts[0]);
        let lessionOrAudioBookId = parseInt(parts[1]);

        this.openPayDialog({
          payType: parseInt(payType),
          lessionOrAudioBookId: parseInt(lessionOrAudioBookId)
        });

        return;
      }

      // 可以播放，执行播放逻辑
      await this.handlePlayAction();
    },

    /**
     * 处理播放动作
     * 逻辑：
     * 1. 如果是当前音频（无论播放或暂停）→ 切换播放/暂停状态
     * 2. 如果不是当前音频 → 播放这个新音频
     */
    async handlePlayAction() {
      try {
        // 情况1：点击当前音频（可能正在播放或已暂停）
        if (this.isCurrentTrack) {
          console.log(
            `[SinglePlayCard] 切换播放/暂停: ${
              this.isPlaying ? "暂停" : "播放"
            }`
          );
          // 调用 audioMixin 的切换方法
          // 如果正在播放 → 暂停
          // 如果已暂停 → 继续播放
          this.handleTogglePlay();
          return;
        }

        // 情况2：点击其他音频，播放这个新音频
        console.log("[SinglePlayCard] 播放新音频:", this.info.name);

        // 检查是否有章节列表和课程信息
        if (!this.chapterList || this.chapterList.length === 0) {
          console.error("[SinglePlayCard] 没有章节列表");
          this.$message?.error("章节列表为空");
          return;
        }

        if (!this.courseInfo) {
          console.error("[SinglePlayCard] 没有课程信息");
          this.$message?.error("缺少课程信息");
          return;
        }

        // 每次播放时都先设置播放列表（确保播放列表是最新的）
        console.log("[SinglePlayCard] 设置播放列表");
        console.log(this.courseInfo);

        await this.setPlaylist({
          playlist: this.chapterList,
          info: this.courseInfo
        });

        // 播放指定音轨（mixin 会自动从播放列表中查找索引）
        await this.handlePlayTrack(this.info);
      } catch (error) {
        console.error("[SinglePlayCard] 播放失败:", error);
        this.$message?.error("播放失败，请重试");
      }
    }
  }
};
</script>

<style lang="less" scoped>
@theme-color: #f87527;

.flex-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.containerCard {
  width: 446px;
  height: auto;

  font-family: "PingFang SC";
  font-style: normal;
  line-height: normal;

  .mainArea {
    width: 100%;
    height: auto;

    display: flex;
    justify-content: space-between;
    align-items: center;
    .loading-btn {
      width: 32px;
      height: 32px;
      border: none;
      background: transparent;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s;
      background: @theme-color;
      border-radius: 50%;
    }
    ::v-deep .t-loading__gradient-conic {
      background: conic-gradient(
        from 90deg,
        rgba(0, 82, 217, 0) 0deg,
        rgb(255, 255, 255) 360deg
      ) !important;
    }
    .idMark {
      color: #262626;
      font-size: 12px;
      font-weight: 400;
      height: 100%;
      width: 5px;
      line-height: 36px;
    }

    .intro {
      width: 374px;
      height: 100%;
      color: #262626;
      font-size: 13px;
      font-weight: 400;
      text-align: left;

      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .iconShow {
      width: 32px;
      height: 32px;
      cursor: pointer;

      .play,
      .pause,
      .lock {
        width: 100%;
        height: 100%;
      }
    }
  }

  .mainArea:hover {
    cursor: pointer;
  }

  .mainArea:hover .idMark,
  .mainArea:hover .intro {
    color: #f87527 !important;
  }
  .content-info {
    .flex-center();
    justify-content: left;
    gap: 8px;
    margin-left: 21px;
    color: #999;
    font-size: 11px;
    font-weight: 400;
  }
  .u-margin-right-4 {
    margin-right: 4px;
  }
  .icon-size-12 {
    width: 12px;
    height: 12px;
  }
  .details {
    height: 15px;
    width: 100%;

    margin-left: 21px;
    margin-top: 8px;

    color: #999;
    font-size: 11px;
    font-weight: 400;

    display: flex;
    align-items: center;

    .timeIcon {
      width: 12px;
      height: 12px;

      background-image: url("../../assets/images/icon/lock.png");
      background-size: cover;
    }

    .showTime {
      margin-left: 4px;
    }

    .playTime {
      margin-left: 8px;
    }

    .playIcon {
      width: 12px;
      height: 12px;
      margin-left: 8px;

      background-image: url("../../assets/images/icon/play.png");
      background-size: cover;
    }

    .playVal {
      margin-left: 4px;
    }
  }
}
</style>
